export const actionKey = '@@hub';

//# sourceMappingURL=constants.js.map